import { date } from "@planningcenter/datetime-fmt"
import { SharedFirstNameWarning } from "components/shared/shared_first_name_warning"
import DatePicker from "components/ui/DatePicker"
import moment from "moment-timezone"
import PropTypes from "prop-types"
import { Component } from "react"
import {
  ageInMonthsAtTimeOfEvent,
  meetsAttendeeTypeAgeRestriction
} from "utils/age_restriction_utils"
import { gendersMatch } from "utils/genders_match"
import RegistrationsPropTypes from "utils/prop_types"
import TypeSelectionDropdown from "./type_selection"

class NewAttendeeListItem extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.handleTypeSelectionChange = this.handleTypeSelectionChange.bind(this)
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this)
    this.setAge = this.setAge.bind(this)

    this.state = {
      birthdate: "",
      checked: true,
      attendeeTypeId: "",
      firstName: "",
      lastName: "",
      emailAddress: "",
      age: "",
      gender: "",
      grade: "",
      attendeeType: null,
      householdAdd: false,
      ageRestrictionUnit: "1",
      key: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }

  componentDidMount() {
    this.props.onChange({ ...this.state })
  }

  componentDidUpdate(prevProps, prevState) {
    const { onChange } = this.props
    if (this.state !== prevState) {
      onChange({ ...this.state })
    }
  }

  checkAge(attendeeType) {
    const { birthdate } = this.state
    const evaluateAgeAt = attendeeType.evaluateAgeAt
      ? attendeeType.evaluateAgeAt
      : this.props.eventStartDate

    return meetsAttendeeTypeAgeRestriction(attendeeType, birthdate, evaluateAgeAt)
      ? null
      : this.ageRestrictionText(attendeeType)
  }

  checkGrade(grade, attendeeType) {
    let minGrade = attendeeType.minGrade
    let maxGrade = attendeeType.maxGrade
    if (grade === "") {
      return this.gradeRestrictionText(attendeeType)
    }
    if (minGrade == null) {
      minGrade = -1
    }
    if (maxGrade == null) {
      maxGrade = 12
    }
    return minGrade <= grade && grade <= maxGrade ? null : this.gradeRestrictionText(attendeeType)
  }

  checkGender(gender, attendeeType) {
    return gendersMatch(attendeeType.genderRestrictionUnit, gender)
      ? null
      : this.genderRestrictionText(attendeeType)
  }

  render() {
    const {
      attendeeTypes,
      households,
      gradeOptions,
      genderOptions,
      mobileBrowser,
      eventStartDate
    } = this.props
    const {
      attendeeTypeId,
      checked,
      key,
      firstName,
      lastName,
      emailAddress,
      gender,
      grade,
      attendeeType,
      householdAdd,
      birthdate
    } = this.state

    const { momentDateFormat } = App.currentOrganization

    return (
      <div>
        {!checked ? (
          <div />
        ) : (
          <div className="action-drawer mb-1">
            <div className="d-f">
              <div>
                <input
                  type="checkbox"
                  className="large-checkbox checkbox"
                  name={key}
                  id={key}
                  checked={checked}
                  onChange={this.handleCheckboxClick}
                  onClick={this.handleCheckboxClick}
                />
                <label htmlFor={key} className="large-checkbox-label checkbox-label" />
              </div>
              <div className="ml-1 f-1">
                <div>
                  <div className="d-f@md f_1">
                    <div className="mb-1 mr-4p@md">
                      <input
                        type="text"
                        value={firstName}
                        onChange={e => this.handleChange({ firstName: e.target.value })}
                        autoComplete="off"
                        placeholder="First name"
                        disabled={!checked}
                      />
                    </div>
                    <div className="mb-1 ml-4p@md">
                      <input
                        type="text"
                        value={lastName}
                        onChange={e => this.handleChange({ lastName: e.target.value })}
                        autoComplete="off"
                        placeholder="Last name"
                        disabled={!checked}
                      />
                    </div>
                  </div>
                  <SharedFirstNameWarning firstName={firstName} />
                  <div className="mb-1">
                    <input
                      type="text"
                      value={emailAddress}
                      onChange={e => this.handleChange({ emailAddress: e.target.value })}
                      autoComplete="off"
                      placeholder="Email address (optional)"
                      disabled={!checked}
                    />
                  </div>
                  <div>
                    {(households.length === 0 || this.props.currentPersonVerified) && (
                      <div className="mb-2">
                        <input
                          type="checkbox"
                          className="checkbox"
                          checked={householdAdd}
                          id={key + 1}
                          disabled={!checked}
                          readOnly
                        />
                        <label
                          className="checkbox-label"
                          style={{
                            lineHeight: 1
                          }}
                          htmlFor={key + 1}
                          onClick={() => {
                            let householdId
                            if (households.length > 0) {
                              householdId = households[0].accountCenterId
                            } else {
                              householdId = "new"
                            }

                            if (checked) {
                              this.handleChange({
                                householdAdd: !householdAdd,
                                householdId
                              })
                            }
                          }}
                        >
                          <span className="fs-4">This person is in my household</span>
                        </label>
                      </div>
                    )}
                    {households.length > 1 && householdAdd && (
                      <select
                        className="select"
                        value={this.state.householdId}
                        disabled={!checked}
                        onChange={e => this.handleChange({ householdId: e.target.value })}
                      >
                        {households.map(h => (
                          <option value={h.accountCenterId} key={h.accountCenterId}>
                            {h.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
                <TypeSelectionDropdown
                  isOpen={false}
                  attendeeTypeId={attendeeTypeId}
                  attendeeTypes={attendeeTypes}
                  attendee={false}
                  onChange={this.handleTypeSelectionChange}
                  zValue={this.props.zValue}
                />
                {attendeeType != null && (attendeeType.minAge || attendeeType.maxAge) && (
                  <div className="mt-2">
                    <div>
                      <div>
                        <label className="label fw-500">Birthdate</label>
                        <DatePicker
                          datetime={birthdate}
                          format={momentDateFormat}
                          onChange={date =>
                            this.setAge(
                              moment(date).format(momentDateFormat),
                              attendeeType.evaluateAgeAt,
                              eventStartDate
                            )
                          }
                          disabled={!checked}
                          toMonth={new Date()}
                        />
                      </div>
                      {this.checkAge(attendeeType) && (
                        <em className="fs-13 c-tint2 p-r pl-1">{this.checkAge(attendeeType)}</em>
                      )}
                    </div>
                  </div>
                )}
                {attendeeType != null &&
                  (attendeeType.minGrade != null || attendeeType.maxGrade != null) && (
                    <div className="mt-2">
                      <div>
                        <div>
                          <label className="label fw-500">Grade</label>
                          <select
                            name="attendee_type[min_grade]"
                            id="attendee_type_min_grade"
                            className="select w-a"
                            value={grade}
                            disabled={!checked}
                            onChange={e => this.handleChange({ grade: e.target.value })}
                          >
                            {gradeOptions.map(option => (
                              <option key={option[0]} value={option[1]}>
                                {option[0]}
                              </option>
                            ))}
                          </select>
                        </div>
                        {this.checkGrade(grade, attendeeType) && (
                          <em className="fs-13 c-tint2 p-r pl-1">
                            {this.checkGrade(grade, attendeeType)}
                          </em>
                        )}
                      </div>
                    </div>
                  )}
                {attendeeType != null && attendeeType.genderRestrictionUnit && (
                  <div className="mt-2">
                    <div>
                      <div>
                        <label className="label fw-500">Gender</label>
                        <select
                          className="select w-a"
                          value={gender}
                          disabled={!checked}
                          onChange={e => this.handleChange({ gender: e.target.value })}
                        >
                          {genderOptions.map(option => (
                            <option key={option[0]} value={option[1]}>
                              {option[0]}
                            </option>
                          ))}
                        </select>
                      </div>
                      {this.checkGender(gender, attendeeType) && (
                        <em className="fs-13 c-tint2 p-r pl-1">
                          {this.checkGender(gender, attendeeType)}
                        </em>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  setAge(birthdate, evaluateAgeAt, eventStartDate) {
    const dateToUse = evaluateAgeAt ? evaluateAgeAt : eventStartDate
    this.setState({
      birthdate,
      age: ageInMonthsAtTimeOfEvent(birthdate, dateToUse)
    })
  }

  ageRestrictionText(attendeeType) {
    let evaluateAgeAtText = attendeeType.evaluateAgeAt
      ? date(attendeeType.evaluateAgeAt)
      : "event start date"
    let ageRestrictionUnitText = attendeeType.ageRestrictionUnit === 1 ? "year" : "month"
    if (attendeeType.minAge == null && attendeeType.maxAge != null) {
      if (attendeeType.maxAge === 1) {
        return `at most ${attendeeType.maxAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `at most ${attendeeType.maxAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else if (attendeeType.minAge != null && attendeeType.maxAge == null) {
      if (attendeeType.minAge === 1) {
        return `at least ${attendeeType.minAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `at least ${attendeeType.minAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else if (attendeeType.minAge === attendeeType.maxAge) {
      if (attendeeType.maxAge === 1) {
        return `${attendeeType.minAge} ${ageRestrictionUnitText} old by ${evaluateAgeAtText}`
      } else {
        return `${attendeeType.minAge} ${ageRestrictionUnitText}s old by ${evaluateAgeAtText}`
      }
    } else {
      return `${attendeeType.minAge} - ${attendeeType.maxAge} ${ageRestrictionUnitText} olds by ${evaluateAgeAtText}`
    }
  }

  gradeRestrictionText(attendeeType) {
    if (attendeeType.minGrade == null && attendeeType.maxGrade != null) {
      return `all grades up to ${attendeeType.maxGradeToS} grade only`
    } else if (attendeeType.minGrade != null && attendeeType.maxGrade == null) {
      return `${attendeeType.minGradeToS} grade and up`
    } else if (attendeeType.minGrade === attendeeType.maxGrade) {
      return `${attendeeType.minGradeToS} grade only`
    } else {
      return `${attendeeType.minGradeToS} - ${attendeeType.maxGradeToS} grade only`
    }
  }

  genderRestrictionText(attendeeType) {
    return `${attendeeType.genderRestrictionUnit === "M" ? "males" : "females"} only`
  }

  handleCheckboxClick() {
    const checked = !this.state.checked
    const attendeeTypeId = checked ? this.state.attendeeTypeId : ""
    this.handleChange({ checked, attendeeTypeId })
  }

  handleTypeSelectionChange(attendeeTypeId, checked) {
    let attendeeType = this.props.attendeeTypes.find(at => at.id === attendeeTypeId)
    checked = checked === undefined ? !this.state.checked : checked

    if (checked) this.setState({ checked: true })
    this.setState({ attendeeTypeId, attendeeType })
  }

  handleChange(state) {
    this.setState(state)
  }
}

NewAttendeeListItem.propTypes = {
  attendeeTypes: PropTypes.arrayOf(RegistrationsPropTypes.AttendeeType).isRequired,
  households: PropTypes.arrayOf(RegistrationsPropTypes.Household).isRequired,
  onChange: PropTypes.func.isRequired
}

export default NewAttendeeListItem
